import ReminderOptionType from '../helpers/ReminderOptionType';

/**
 * Generates a list of reminder dropdown options smaller than maxReminderTime
 */

export default function generateReminderDropdownOptions(
    allReminderDropdownOptions: ReminderOptionType[],
    maxReminderTime: number
): ReminderOptionType[] {
    let reminderDropdownOptions = [];

    // First add all reminder options that are smaller than maxReminderTime.
    // This list of reminder options will not include none (-1).
    for (let i = 0; i < allReminderDropdownOptions.length; i++) {
        let option = allReminderDropdownOptions[i];

        if (option.key > maxReminderTime) {
            break;
        }
        reminderDropdownOptions.push(option);
    }
    return reminderDropdownOptions;
}
